<template>
  <div class="context-menu bg-gray-100 shadow border-gray-200" @wheel.stop>
    <component :is="menuComponent" :selection="selection" />
  </div>
</template>

<script setup>
import { MODE, TYPE } from '@/constants';

import DrawingMenu from './drawing/Drawing.vue';
import LabelingMenu from './labeling/Labeling.vue';
import GroupingMenu from './grouping/Grouping.vue';
import CategoriesMenu from './categories/Categories.vue';
import PosMenu from './pos/Pos.vue';
import BlockSeatsMenu from './blockseats/Blockseats.vue';
import GaRenderer from './renderer/ga.vue';

import { computed } from 'vue';
import { useState } from '@/store/useStore';

const props = defineProps({
  selection: {
    type: Object,
    required: true,
  },
});

const ContextMenuModaMap = {
  [MODE.DRAWING]: DrawingMenu,
  [MODE.LABELS]: LabelingMenu,
  [MODE.GROUP]: GroupingMenu,
  [MODE.CATEGORIES]: CategoriesMenu,
  [MODE.POS]: PosMenu,
  [MODE.BLOCKSEATS]: BlockSeatsMenu,
};

const menuComponent = computed(() => {
  if (mode.value === MODE.RENDERER && props.selection.type === TYPE.GA) {
    return GaRenderer;
  }
  return ContextMenuModaMap[mode.value] ?? DrawingMenu;
});

const { mode } = useState('settings');
</script>

<style lang="scss">
.context-menu {
  border-left: 1px solid #d9d9d9;
  display: block;
  position: fixed;
  bottom: 0;
  top: 0px;
  margin-top: 60px;
  margin-bottom: 25px;
  right: 0;
  width: 250px;
  overflow: auto;
  &:empty {
    display: none;
  }
}
.vc-chrome {
  width: 210px !important;
  margin: 0px;
  padding: 0px !important;
}
</style>
